import * as React from 'react';
import { observer } from 'mobx-react';
import Loader from '../Loader';
import FlashMessage from '../FlashMessage';
import VisualizationEmbedStore from '../../VisualizationEmbedStore';
import QuickSightVisualizationEmbed from './QuickSightVisualizationEmbed';
import { quickSightVizFn } from './quickSightEmbedAPILoader';
import { DashboardType } from '../../ReportStore/Types';

interface QuickSightParameter {
  Name: string;
  Values: string[];
}

interface Props {
  visualizationPath: string;
  height: string;
  width: string;
  onReady: () => void;
  store: VisualizationEmbedStore;
  dashboardType: DashboardType;
  onDashboardReady?: (dashboard: any) => void;
  parameters?: QuickSightParameter[];
}

const VisualizationEmbedState: React.FC<Props> = (props) => {
  switch (props.store.state.kind) {
    case 'waiting':
    case 'loading':
      return <Loader />;
    case 'ready':
      switch (props.dashboardType) {
        case 'quicksight':
          return (
            <QuickSightVisualizationEmbed
              vizFn={props.store.visualizationFn as quickSightVizFn}
              visualizationPath={props.visualizationPath}
              visualizationToken={props.store.state.visualizationToken.value}
              width={props.width}
              height={props.height}
              onReady={props.onReady}
              onDashboardReady={props.onDashboardReady}
              parameters={props.parameters}
            />
          );
        default:
          console.error(`Unsupported dashboard type: ${props.dashboardType}`);
          return <></>;
      }
    case 'error':
      return props.store.notification
        .map((alert) => <FlashMessage alert={alert} />)
        .getOrElse(() => <></>);
  }
};

export default observer(VisualizationEmbedState);
